"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var LineChart_meta_1 = require("./LineChart.meta");
var ChartBaseFunctions_1 = require("../ChartBase/ChartBaseFunctions");
var ChartBase_1 = __importDefault(require("../ChartBase"));
var LineChart = /** @class */ (function (_super) {
    __extends(LineChart, _super);
    function LineChart(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = LineChart_meta_1.LINE_CHART_CATEGORY_KEY;
        _this.componentKey = LineChart_meta_1.LINE_CHART_COMPONENT_KEY;
        return _this;
    }
    Object.defineProperty(LineChart.prototype, "chartBaseProps", {
        get: function () {
            var _a = this.props, elementOverrides = _a.elementOverrides, dateOptions = _a.dateOptions;
            var data = this.props.data;
            if (elementOverrides) {
                var xAxis = elementOverrides.xAxis, yAxis = elementOverrides.yAxis;
                if (dateOptions) {
                    if (xAxis && dateOptions.xAxisDateAsNumber) {
                        data = ChartBaseFunctions_1.useAxisDateAsNumber(xAxis, data);
                    }
                    if (yAxis && dateOptions.yAxisDateAsNumber) {
                        data = ChartBaseFunctions_1.useAxisDateAsNumber(yAxis, data);
                    }
                }
            }
            return ChartBaseFunctions_1.getChartBaseProps({ type: 'Line' }, this.configuration, __assign(__assign({}, this.props), { data: data }));
        },
        enumerable: true,
        configurable: true
    });
    LineChart.prototype.render = function () {
        var className = this.props.className;
        return (react_1.default.createElement(Wrapper_1.default, { className: className },
            react_1.default.createElement(ChartBase_1.default, __assign({}, this.chartBaseProps))));
    };
    LineChart = __decorate([
        mobx_react_1.observer
    ], LineChart);
    return LineChart;
}(shared_1.ComponentBase));
exports.LineChart = LineChart;
exports.default = shared_1.InjectedStyledComponent(LineChart, LineChart_meta_1.LINE_CHART_CATEGORY_KEY, LineChart_meta_1.LINE_CHART_COMPONENT_KEY);
